module.exports = __webpack_public_path__ + "static/media/topcoder.f3c286f8.png";